import * as React from "react";
import * as Google from "expo-auth-session/providers/google";
import Constants from "expo-constants";

import { SocialButton } from "~/components/button";
import { ButtonTypes } from "~/components/button/types";

import { useAppDispatch } from "~/state/hooks";

import { loginWithGoogle } from "~/state/user/actions";

interface Props {
  text: TextType;
}

export const GoogleButton = ({ text }: Props) => {
  const dispatch = useAppDispatch();

  const [request, response, promptAsync] = Google.useIdTokenAuthRequest({
    webClientId: Constants?.expoConfig?.extra?.clientId,
    expoClientId: Constants?.expoConfig?.extra?.clientId,
    iosClientId: Constants?.expoConfig?.extra?.appClientId,
    androidClientId: Constants?.expoConfig?.extra?.appClientId,
    scopes: ["email", "profile"],
  });

  React.useEffect(() => {
    if (response?.type === "success") {
      const { id_token } = response.params;
      dispatch(loginWithGoogle({ idToken: id_token }));
    }
  }, [response, dispatch]);

  return (
    <SocialButton
      text={text}
      onPress={() => promptAsync()}
      type={ButtonTypes.Google}
    />
  );
};
